import { AxiosInstance, AxiosResponse } from 'axios';

export function UseQaInterceptor(instance: AxiosInstance) {
    instance.interceptors.response.use(qaInterceptor, _ => _);
}

function qaInterceptor(response: AxiosResponse<any>) {
    response.status = Number(prompt(`Input response Status Code for ${response.config.url}`, '200')) ||  response.status ;

    if (response.status >= 400) {
        // eslint-disable-next-line no-throw-literal
        throw { response: response};
    }

    return response;
}
